module.exports = __webpack_public_path__ + "static/img/mariedalgar.215f158.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/case/mariedalgar.png
// module id = I0jI
// module chunks = 34